import { object, string } from "yup";

export const VALIDATION_SCHEMA = object().shape({
  username: string().required("Harus diisi"),
  password: string().required("Harus diisi"),
});

export const getDefaultValues = () => {
  if (import.meta.env.MODE === "development") {
    return {
      username: import.meta.env.VITE_SUPER_ADMIN_USERNAME || "",
      password: import.meta.env.VITE_SUPER_ADMIN_PASSWORD || "",
    };
  }
  return { username: "", password: "" };
};
